import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { machinesEventsConfig } from '@v2/pages/machines/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const MachinesEventsStack = createStackNavigator();

const MachinesEventsNavigator = () => {
  return (
    <MachinesEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {machinesEventsConfig.map(({ Component, name }) => (
        <MachinesEventsStack.Screen key={name} name={name} component={Component} />
      ))}
    </MachinesEventsStack.Navigator>
  );
};

export { MachinesEventsNavigator };
